import { Stack } from '@mantine/core';
import { RewardsRankItem } from './RewardsRankItem';
import { ranks } from './data';
export const VipRewardsRank: React.FC = () => {
  return <Stack mt={20} gap={12}>
      {ranks.map(item => <RewardsRankItem key={item.text} {...item} />)}
    </Stack>;
};